import gql from "graphql-tag";

export const MY_TIMESHEET_CREATE_TIMESHEET = gql`
  mutation createMysheetTimesheet(
    $name: String!
    $description: String
    $startTime: Date
    $endTime: Date
    $projectId: String
    $clientId: String
    $costId: String
    $validFrom: Date
    $validTo: Date
  ) {
    createMysheetTimesheet(
      name: $name
      description: $description
      startTime: $startTime
      endTime: $endTime
      projectId: $projectId
      clientId: $clientId
      costId: $costId
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      startTime
      endTime
      projectId
      clientId
      costId
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      state
    }
  }
`;
